import { render } from "./ProductManagement.vue?vue&type=template&id=4d2462e5"
import script from "./ProductManagement.vue?vue&type=script&lang=js"
export * from "./ProductManagement.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__